import { Injectable, Inject } from '@angular/core';
import { AlertController } from 'ionic-angular';

@Injectable()
export class CustomAlert {
  public alert: any;
    constructor(public alertCtrl: AlertController) { }

    showAlert(title: string, subtitle: string) {
        let Alert = this.alertCtrl.create({
            title: title,
            subTitle: subtitle,
            buttons: ['OK']
        })

        Alert.present();
    }

    showAlertWithCallback(title: string, subtitle: string, btnText: string, func: () => any) {
        this.alert = this.alertCtrl.create({
            title: title,
            subTitle: subtitle,
            enableBackdropDismiss: false,
            buttons: [{
                text: btnText,
                handler: () => {
                    if (func())
                        this.alert.dismiss();
                }
            }]
        })

        this.alert.present();
    }

    showAlertWithDismiss(title: string, subtitle: string, func: () => any) {
        this.alert = this.alertCtrl.create({
            title: title,
            subTitle: subtitle,
            buttons: ['OK']
        })

        this.alert.dismiss().then(() => {
            func();
        });

        this.alert.present();
    }

    showConfirm(title: string, subtitle: string, btnYesText: string, btnNoText: string, funcYes: () => any) {
        this.alert = this.alertCtrl.create({
            title: title,
            subTitle: subtitle,
            buttons: [
                {
                    text: btnNoText,
                    handler: () => {

                    }
                },
                {
                    text: btnYesText,
                    handler: () => {
                        funcYes();
                    }
                },
            ]
        })
        this.alert.present();
    }

    dismiss(){
      this.alert.dismiss();
    }

}



// WEBPACK FOOTER //
// ./src/components/custom-alert.component.ts